import React, { useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import * as XLSX from "xlsx";
import axiosMain from "../../../http/axios/axios_main";
import { useEffect } from "react";
import { useState } from "react";
import CustomToast from "../../../components/Toast";
import "react-toastify/dist/ReactToastify.css";
import Modal from "../../../components/common/Modal";
import {
  checkAllcoulm,
  readFileAndCheckHeaders,
} from "../../../components/common/uploadFile/utils";
import { useAuctionDetail } from "../../../components/common/AunctioneerDeteailProvider";
import TableComponent from "../../../components/tableComponent/TableComponent";
import axios from "axios";
import { Button, Card } from "react-bootstrap";
import { useLoader } from "../../../components/common/Loder/Loder";
import formatDateToDdMmYy from "../../../components/common/dateAndTime/convertToDate";
import Modals from "../../../components/common/Modal";

import { fetchSaleNumbersRequest } from "../../../store/actions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { FormControl, InputGroup } from "react-bootstrap";

const initialValues = {
  season: "",
  saleNo: "0",
};
const validationSchema = Yup.object().shape({
  saleNo: Yup.number()
    .min(1, "Please select Sale No")
    .required("Sale No is required"),
  season: Yup.string().required("Please select Season"),
});

const UploadValuationForm = ({
  auctionCatalogDetail,
  loggedUser,
  setOpenUploadValuation,
  setMyCatalogRows,
  timeData,
  baseUrlEng,
  kuchacatalogValuaction,
  getKuchaData,
  teatypeList,
  userRole,
}) => {
  const {
    auctionDetailId,
    auctionCenterUserId,
    auctionCenterId,
    userId,
    roleCode,
  } = useAuctionDetail();
  const currentYear = new Date().getFullYear();
  const { isLoading, openLoader, closeLoader, toggleLoader } = useLoader();
  const dispatch = useDispatch();
  // console.log(baseUrlEng, "baseUrlEngbaseUrlEngbaseUrlEng");
  const [files, setFiles] = useState([]);
  const [rows, setRows] = useState([]);
  const [valuationData, setValuationData] = useState([]);
  const [saleProgramid, setSaleProgramid] = useState(null);
  const [uploadrows, setuploadRows] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [valcount, setvalCount] = useState(0);
  const [newMessage, setnewMessage] = useState("");
  const uploadtablecolumn =
    (baseUrlEng === "EnglishAuctionCatalog" ||
      baseUrlEng === "EnglishAuctionKutchaCatalogue") &&
      baseUrlEng !== "EnglishAuctionBuyer"
      ? [
        { name: "LotNo", title: "Lot No" },
        { name: "basePrice", title: "Base Price" },
        { name: "reservePrice", title: "Reserve Price" },
        { name: "auctioneerValuation", title: "Auctioneer's Valuation" },
        { name: "markPackageComments", title: "Mark and Packaging Comments" },
        { name: "lotComments", title: "Lot Comments" },
        { name: "qualityComments", title: "Quality Comments" },
        { name: "SampleQty", title: "SampleQty(Kgs)" },
        { name: "sessionType", title: "Session Type" },
      ]
      : baseUrlEng === "AuctionCatalog"
        ? [
          { name: "LotNo", title: "Lot No" },
          { name: "basePrice", title: "Base Price" },
          { name: "reservePrice", title: "Reserve Price" },
          { name: "auctioneerValuation", title: "Auctioneer's Valuation" },
          { name: "markPackageComments", title: "Mark and Packaging Comments" },
          { name: "lotComments", title: "Lot Comments" },
          { name: "qualityComments", title: "Quality Comments" },
          { name: "SampleQty", title: "SampleQty(Kgs)" },
          { name: "sessionType", title: "Session Type" },

          { name: "priceIncrement", title: "Price Increment" },
          { name: "gardenCertification", title: "Garden Certification" },
          { name: "qualityCertification", title: "Quality Certification" },
          { name: "brewColor", title: "Colour of brew" },
          { name: "ageOfProducts", title: "Age of Product (In months)" },
          { name: "brewersComments", title: "Brewers Comments" },
        ]
        : [
          { name: "lotNo", title: "Lot No" },
          { name: "myValuation", title: "My Valuation" },
          { name: "myComments", title: "My Comments" },
          { name: "groupCode", title: "Group Code" },
          { name: "gradeCode", title: "Grade Code" },
          { name: "markCode", title: "Mark Code" },
        ];
  console.log(uploadtablecolumn, "baseUrlEngbaseUrlEngbaseUrlEng");
  useEffect(() => {
    getSaleProgramId(auctionCatalogDetail.season, auctionCatalogDetail.saleNo);
  }, []);
  const [saleNumber, setsaleNumber] = useState([]);

  function generateYearOptions() {
    const currentYear = new Date().getFullYear();
    const options = [];

    for (let i = currentYear; i > currentYear - 7; i--) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }

    return options;
  }
  const formik = useFormik({
    initialValues: initialValues,

    validationSchema,
    onSubmit: (values) => {
      fileInputRef.current.click();
    },
  });

  useEffect(() => {
    const season = formik.values.season?.toString();
    if ((season !== "") & (season !== undefined)) {
      debugger;
      const seasondata = {
        season: formik.values.season.toString(),
        auctionCenterId: auctionCenterId,
      };
      axiosMain
        .post(`/preauction/Common/BindSaleNoBySeason`, seasondata)
        .then((res) => {
          setsaleNumber(res.data.responseData);
          // formik.setFieldValue("saleNo", res.data.responseData?.at(0).saleNo);
        })
        .catch((err) => console.log(err));
      // dispatch(fetchSaleNumbersRequest(formik.values.season));
    }
  }, [formik.values.season]);
  const { handleChange, handleBlur, values, touched, errors } = formik;

  const fileInputRef = useRef(null);
  function fixKeyNames(obj) {
    const newObj = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        let fixedKey = key.replace("/", "_"); // Replace '/' with '_'
        fixedKey = fixedKey.replace(".No", "No");
        newObj[fixedKey] = obj[key];
      }
    }

    return newObj;
  }
  function findDuplicateInvoiceNumbers(arrayOfObjects) {
    const invoiceNumbers = new Map();
    const duplicateInvoices = [];

    arrayOfObjects.forEach((obj) => {
      if (invoiceNumbers.has(obj.LotNo)) {
        duplicateInvoices.push(obj.LotNo);
      }
      invoiceNumbers.set(obj.LotNo, true);
    });

    return duplicateInvoices;
  }
  function findDuplicateInvoiceNumbersbuyer(arrayOfObjects) {
    const invoiceNumbers = new Map();
    const duplicateInvoices = [];

    arrayOfObjects.forEach((obj) => {
      if (invoiceNumbers.has(obj.lotNo)) {
        duplicateInvoices.push(obj.lotNo);
      }
      invoiceNumbers.set(obj.lotNo, true);
    });

    return duplicateInvoices;
  }

  const handleSubmit = async () => {
    // if (files.length === 0) {
    //   CustomToast.error("Please select one or more files to upload");
    //   return;
    // }
    fileInputRef.current.value = "";
    console.log(auctionCatalogDetail, valuationData, "rowsrowsrowsrows");
    const filteredData = valuationData; //.filter((item) => item.LotNo !== null);
    //debugger;
    let invalidDataIndex = -1;
    //---AD
    if (userRole !== "buyer" && baseUrlEng === "EnglishAuctionKutchaCatalogue") {
      //edied By Samar
      const duplicates = findDuplicateInvoiceNumbers(filteredData);
      //check lot no
      const blankLots = filteredData
        .map((ele, index) => {
          if (
            ele.LotNo === "" ||
            ele.LotNo === null ||
            ele.LotNo === undefined
          ) {
            return index + 1;
          }
        })
        .filter(Boolean);

      if (blankLots.length > 0) {
        CustomToast.error(
          "Please Enter Lot No in Row No " + blankLots.join(",")
        );
        return false;
      }
      const uniq = [...new Set(duplicates)];
      if (duplicates.length > 0) {
        CustomToast.error(
          "Lot No" + " " + uniq.join(", ") + " " + "is already exist"
        );
        return false;
      }
      if (
        valuationData
          .map(
            (ele) =>
              ele.SampleQty !== null &&
              ele.SampleQty !== "" &&
              // typeof ele.SampleQty === "number" &&
              !isNaN(Number(ele.SampleQty))
          )
          .includes(false)
      ) {
        const rowinvalid = //selectedData
          valuationData
            .map(
              (ele, index) =>
                ele.SampleQty !== null &&
                ele.SampleQty !== "" &&
                //typeof ele.SampleQty === "number" &&
                !isNaN(Number(ele.SampleQty))
            )
            .map((ele, index) => ele === false && index + 1)
            .filter((ele) => ele != false);
        CustomToast.error(
          "Please enter Valid SampleQty value in row no. " + rowinvalid + " "
        );
        return false;
      }

      if (
        valuationData
          .map(
            (ele) =>
              ele.reservePrice !== null &&
              ele.reservePrice !== "" &&
              // typeof ele.reservePrice === "number" &&
              !isNaN(Number(ele.reservePrice))
            // &&
            // ele.reservePrice > 0
          )
          .includes(false)
      ) {
        const rowinvalid = //selectedData
          valuationData
            .map((ele, index) =>
              ele.reservePrice !== null &&
                ele.reservePrice !== "" &&
                // typeof ele.reservePrice === "number" &&
                !isNaN(Number(ele.reservePrice))
                // &&
                // ele.reservePrice > 0
                ? ""
                : ele.LotNo
            )
            // .map((ele, index) => ele === false && index + 1)
            .filter((ele) => ele != "");
        CustomToast.error(
          "Please enter appropriate Reserve Price value in lot no. " +
          rowinvalid +
          " "
        );
        return false;
      }

      if (
        valuationData
          .map(
            (ele) =>
              ele.auctioneerValuation !== null &&
              ele.auctioneerValuation !== "" &&
              // typeof ele.auctioneerValuation === "number" &&
              !isNaN(Number(ele.auctioneerValuation))
            // &&
            // ele.auctioneerValuation > 0
          )
          .includes(false)
      ) {
        const rowinvalid = //selectedData
          valuationData
            .map((ele, index) =>
              ele.auctioneerValuation !== null &&
                ele.auctioneerValuation !== "" &&
                // typeof ele.auctioneerValuation === "number" &&
                !isNaN(Number(ele.auctioneerValuation))
                // &&
                // ele.auctioneerValuation > 0
                ? ""
                : ele?.LotNo
            )
            // .map((ele, index) => ele === false && ele.LotNo)
            .filter((ele) => ele !== "");
        CustomToast.error(
          "Please enter appropriate Auction Valuation value in lot no. " +
          rowinvalid +
          " "
        );
        return false;
      }

      if (
        valuationData
          .map(
            (ele) =>
              ele.basePrice !== null &&
              ele.basePrice !== "" &&
              // typeof ele.basePrice === "number" &&
              !isNaN(Number(ele.basePrice))
            // &&
            // ele.basePrice > 0
          )
          .includes(false)
      ) {
        const rowinvalid = //selectedData
          valuationData
            .map((ele, index) =>
              ele.basePrice !== null &&
                ele.basePrice !== "" &&
                // typeof ele.basePrice === "number" &&
                !isNaN(Number(ele.basePrice))
                //  &&
                // ele.basePrice > 0
                ? ""
                : ele?.LotNo
            )
            // .map((ele, index) => ele === false && index + 1)
            .filter((ele) => ele != false);
        CustomToast.error(
          "Blank / Zero value should not be allowed in lot no. " +
          rowinvalid +
          " "
        );
        return false;
      }
      if (
        valuationData
          .map(
            (ele) =>
              ele.sessionType !== null &&
              ele.sessionType !== "" && ele.sessionType !== undefined
            // &&
            // ele.basePrice > 0
          )
          .includes(false)
      ) {
        const rowinvalid1 = //selectedData
          valuationData
            .map((ele, index) =>
              ele.sessionType !== null &&
                ele.sessionType !== "" && ele.sessionType !== undefined
                ? ""
                : ele?.LotNo
            )
            // .map((ele, index) => ele === false && index + 1)
            .filter((ele) => ele != false);
        CustomToast.error(
          "Please Select Session Type in lot no. " +
          rowinvalid1 +
          " "
        );
        return false;
      }
    }
    //end
    if (userRole !== "buyer" && baseUrlEng !== "EnglishAuctionKutchaCatalogue") {
      //edied By Samar
      const duplicates = findDuplicateInvoiceNumbers(filteredData);
      //check lot no
      const blankLots = filteredData
        .map((ele, index) => {
          if (
            ele.LotNo === "" ||
            ele.LotNo === null ||
            ele.LotNo === undefined
          ) {
            return index + 1;
          }
        })
        .filter(Boolean);

      if (blankLots.length > 0) {
        CustomToast.error(
          "Please Enter Lot No in Row No " + blankLots.join(",")
        );
        return false;
      }
      const uniq = [...new Set(duplicates)];
      if (duplicates.length > 0) {
        CustomToast.error(
          "Lot No" + " " + uniq.join(", ") + " " + "is already exist"
        );
        return false;
      }
      if (
        valuationData
          .map(
            (ele) =>
              ele.SampleQty !== null &&
              ele.SampleQty !== "" &&
              typeof ele.SampleQty === "number" &&
              !isNaN(ele.SampleQty)
          )
          .includes(false)
      ) {
        const rowinvalid = //selectedData
          valuationData
            .map(
              (ele, index) =>
                ele.SampleQty !== null &&
                ele.SampleQty !== "" &&
                typeof ele.SampleQty === "number" &&
                !isNaN(ele.SampleQty)
            )
            .map((ele, index) => ele === false && index + 1)
            .filter((ele) => ele != false);
        CustomToast.error(
          "Please enter Valid SampleQty value in row no. " + rowinvalid + " "
        );
        return false;
      }

      if (
        valuationData
          .map(
            (ele) =>
              ele.reservePrice !== null &&
              ele.reservePrice !== "" &&
              typeof ele.reservePrice === "number" &&
              !isNaN(ele.reservePrice) &&
              ele.reservePrice > 0
          )
          .includes(false)
      ) {
        const rowinvalid = //selectedData
          valuationData
            .map((ele, index) =>
              ele.reservePrice !== null &&
                ele.reservePrice !== "" &&
                typeof ele.reservePrice === "number" &&
                !isNaN(ele.reservePrice) &&
                ele.reservePrice > 0
                ? ""
                : ele.LotNo
            )
            // .map((ele, index) => ele === false && index + 1)
            .filter((ele) => ele != "");
        CustomToast.error(
          "Please enter appropriate Reserve Price value in lot no. " +
          rowinvalid +
          " "
        );
        return false;
      }

      if (
        valuationData
          .map(
            (ele) =>
              ele.auctioneerValuation !== null &&
              ele.auctioneerValuation !== "" &&
              typeof ele.auctioneerValuation === "number" &&
              !isNaN(ele.auctioneerValuation) &&
              ele.auctioneerValuation > 0
          )
          .includes(false)
      ) {
        const rowinvalid = //selectedData
          valuationData
            .map((ele, index) =>
              ele.auctioneerValuation !== null &&
                ele.auctioneerValuation !== "" &&
                typeof ele.auctioneerValuation === "number" &&
                !isNaN(ele.auctioneerValuation) &&
                ele.auctioneerValuation > 0
                ? ""
                : ele?.LotNo
            )
            // .map((ele, index) => ele === false && ele.LotNo)
            .filter((ele) => ele !== "");
        CustomToast.error(
          "Please enter appropriate Auction Valuation value in lot no. " +
          rowinvalid +
          " "
        );
        return false;
      }

      if (
        valuationData
          .map(
            (ele) =>
              ele.basePrice !== null &&
              ele.basePrice !== "" &&
              typeof ele.basePrice === "number" &&
              !isNaN(ele.basePrice) &&
              ele.basePrice > 0
          )
          .includes(false)
      ) {
        const rowinvalid = //selectedData
          valuationData
            .map((ele, index) =>
              ele.basePrice !== null &&
                ele.basePrice !== "" &&
                typeof ele.basePrice === "number" &&
                !isNaN(ele.basePrice) &&
                ele.basePrice > 0
                ? ""
                : ele?.LotNo
            )
            // .map((ele, index) => ele === false && index + 1)
            .filter((ele) => ele != false);
        CustomToast.error(
          "Blank / Zero Base Price value should not be allowed in lot no. " +
          rowinvalid +
          " "
        );
        return false;
      }

      // invalidDataIndex = valuationData.findIndex(
      //   (ele) =>
      //     isNaN(parseInt(ele.auctioneerValuation)) ||
      //     isNaN(parseInt(ele.basePrice)) ||
      //     isNaN(parseInt(ele.reservePrice)) ||
      //     isNaN(parseInt(ele.SampleQty))
      // );
      // if (invalidDataIndex !== -1) {
      //   const invalidRow = valuationData[invalidDataIndex];
      //   const invalidRowNumber = invalidDataIndex + 1; // Adding 1 because array index starts from 0
      //   const invalidValues = {
      //     auctioneerValuation: invalidRow.auctioneerValuation,
      //     basePrice: invalidRow.basePrice,
      //     reservePrice: invalidRow.reservePrice,
      //     SampleQty: invalidRow.SampleQty,
      //   };
      //   console.log(
      //     // valuationData?.some(
      //     //   (ele) =>
      //     //     parseInt(ele.auctioneerValuation) &&
      //     //     parseInt(ele.basePrice) &&
      //     //     parseInt(ele.reservePrice) &&
      //     //     parseInt(ele.SampleQty)
      //     // ),
      //     invalidRowNumber,
      //     invalidRow,
      //     invalidValues,
      //     "valuationDatavaluationData"
      //   );
      // }
    }
    if (userRole !== "buyer" && baseUrlEng === "AuctionCatalog") {
      if (
        filteredData.filter(
          (ele) =>
            ele.priceIncrement === null ||
            ele.priceIncrement === undefined ||
            ele.priceIncrement === ""
        )?.length > 0
      ) {
        CustomToast.error(
          "Please enter Price Increment lot no: " +
          filteredData
            .filter(
              (ele) =>
                ele.priceIncrement === null ||
                ele.priceIncrement === undefined ||
                ele.priceIncrement === ""
            )
            ?.map((ele) => ele.LotNo)
            ?.join(", ")
        );
        return false;
      }
      if (
        filteredData.filter(
          (ele) => !/^[0-9]+(\.[0-9]+)?$/.test(ele.priceIncrement)
        )?.length > 0
      ) {
        CustomToast.error(
          "Please enter appropriate Price Increment in lot no: " +
          filteredData
            .filter((ele) => !/^[0-9]+(\.[0-9]+)?$/.test(ele.priceIncrement))
            ?.map((ele) => ele.LotNo)
            ?.join(", ")
        );
        debugger;
        return false;
      }

      if (
        filteredData.filter(
          (ele) =>
            ele.gardenCertification === null ||
            ele.gardenCertification === undefined ||
            ele.gardenCertification === ""
        )?.length > 0
      ) {
        CustomToast.error(
          "Please enter Garden Certificationin lot no: " +
          filteredData
            .filter(
              (ele) =>
                ele.gardenCertification === null ||
                ele.gardenCertification === undefined ||
                ele.gardenCertification === ""
            )
            ?.map((ele) => ele.LotNo)
            ?.join(", ")
        );
        return false;
      }
      // if (
      //   filteredData.filter(
      //     (ele) =>
      //       !/^(?=.*[a-zA-Z])[a-zA-Z0-9]+(,[a-zA-Z0-9]+)*$/.test(
      //         ele.gardenCertification
      //       )
      //   )?.length > 0
      // )
      if (
        filteredData.filter(
          (ele) =>
            !/^(?=.*[a-zA-Z])[a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>]+(,[a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>]+)*$/.test(
              ele.gardenCertification
            )
        )?.length > 0
      ) {
        CustomToast.error(
          "Please enter appropriate Garden Certification in lot no: " +
          filteredData
            .filter(
              (ele) =>
                !/^(?=.*[a-zA-Z])[a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>]+(,[a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>]+)*$/.test(
                  ele.gardenCertification
                )
            )
            ?.map((ele) => ele.LotNo)
            ?.join(", ")
        );
        // debugger;
        return false;
      }

      if (
        filteredData.filter(
          (ele) =>
            ele.ageOfProducts === null ||
            ele.ageOfProducts === undefined ||
            ele.ageOfProducts === ""
        )?.length > 0
      ) {
        CustomToast.error(
          "Please enter Age of the Tea (In Months) lot no: " +
          filteredData
            .filter(
              (ele) =>
                ele.ageOfProducts === null ||
                ele.ageOfProducts === undefined ||
                ele.ageOfProducts === ""
            )
            ?.map((ele) => ele.LotNo)
            ?.join(", ")
        );
        return false;
      }
      if (
        filteredData.filter(
          (ele) => !/^[0-9]{0,3}$/.test(parseInt(ele.ageOfProducts))
        )?.length > 0
      ) {
        CustomToast.error(
          "Please enter appropriate Age of the Tea (In Months) in lot no: " +
          filteredData
            .filter(
              (ele) => !/^[0-9]{0,3}$/.test(parseInt(ele.ageOfProducts))
            )
            ?.map((ele) => ele.LotNo)
            ?.join(", ")
        );
        // debugger;
        return false;
      }
    }

    //sss
    if (userRole === "buyer") {
      const duplicates = findDuplicateInvoiceNumbersbuyer(filteredData);
      const uniq = [...new Set(duplicates)];
      if (duplicates.length > 0) {
        CustomToast.error(
          "Lot No" + " " + uniq.join(", ") + " " + "is already exist"
        );
        return false;
      }
      //check lot no
      const blankLots = filteredData
        .map((ele, index) => {
          if (
            ele.lotNo === "" ||
            ele.lotNo === null ||
            ele.lotNo === undefined
          ) {
            return index + 1;
          }
        })
        .filter(Boolean);
      const blankmyValuation = filteredData
        .map((ele, index) => {
          if (
            ele.myValuation === "" ||
            ele.myValuation === null ||
            ele.myValuation === undefined
          ) {
            return index + 1;
          }
        })
        .filter(Boolean);
      const blankmyComments = filteredData
        .map((ele, index) => {
          if (
            ele.myComments === "" ||
            ele.myComments === null ||
            ele.myComments === undefined
          ) {
            return index + 1;
          }
        })
        .filter(Boolean);

      if (blankLots.length > 0) {
        CustomToast.error(
          "Please Enter Lot No in Row No " + blankLots.join(",")
        );
        return false;
      }

      const numericIndices = filteredData
        .map((ele, index) => {
          if (
            typeof (ele.myValuation === null ? 0 : ele.myValuation) !== "number"
          ) {
            return index + 1;
          }
        })
        .filter(Boolean);

      // if (blankmyValuation.length > 0) {
      //   CustomToast.error("Please Enter My Valuation Row No " + blankmyValuation.join(","));
      //   return false;
      // }
      //let valcount = 0;
      if (numericIndices.length > 0) {
        CustomToast.error(
          "Please Enter Numeric Value in My Valuation Row No " +
          numericIndices.join(",")
        );
        return false;
      }
      // if (filteredData.length > 0) {
      //   await axiosMain
      //     .post(
      //       // `/preauction/${baseUrlEng}/GetMyCatalogValuation?role`,
      //       `/preauction/${baseUrlEng}/GetMyCatalogValuation`,
      //       filteredData
      //       // {
      //       //   lotNo: lotno.replace(/\s/g, ""),
      //       //   myValuation: parseFloat(myValuation),
      //       //   myComments: myComments,
      //       //   groupCode: groupCode,
      //       //   auctionCenterId: auctionCenterId,
      //       // }
      //     )
      //     .then((res) => {
      //       if (res.data.statusCode === 200) {
      //         //CustomToast.success(res.data.message);
      //         setuploadRows(res.data.responseData);
      //       } else {
      //         valcount = 1;
      //         CustomToast.error(res.data.message);
      //         return false;
      //       }
      //     })
      //     .catch((err) => { });
      // }
      if (valcount > 0) {
        CustomToast.error(newMessage);
        return false;
      }

      // if (blankmyComments.length > 0) {
      //   CustomToast.error("Please Enter My Comments Row No " + blankmyComments.join(","));
      //   return false;
      // }
    }

    // const filteredData = valuationData; //.filter((item) => item.LotNo !== null);

    openLoader();

    // if (invalidDataIndex === -1) {
    axiosMain
      .post(
        userRole === "buyer"
          ? `/preauction/${baseUrlEng}/AddValuation?validateAction=validate&dataFlag=Excel&season=` +
          formik.values.season +
          "&saleNo=" +
          formik.values.saleNo
          : kuchacatalogValuaction
            ? `/preauction/EnglishAuctionKutchaCatalogue/UpdateKutchaCatalogueDetails?validateAction=validate&season=` +
            formik.values.season +
            "&saleNo=" +
            formik.values.saleNo
            : `/preauction/${baseUrlEng}/UploadValuation?role=` +
            roleCode +
            "&validateAction=validate&season=" +
            formik.values.season +
            "&saleNo=" +
            formik.values.saleNo,
        kuchacatalogValuaction
          ? filteredData.map((ele) => {
            delete ele.createdOn;
            let data = {
              ...ele,
              saleNo: parseInt(auctionCatalogDetail.saleNo),
              sessionTypeName: ele.sessionType,
              lotComments:
                ele.lotComments === null || ele.lotComments === undefined
                  ? ""
                  : ele.lotComments?.toString(),
              markPackageComments:
                ele.markPackageComments === null ||
                  ele.markPackageComments === undefined
                  ? ""
                  : ele.markPackageComments.toString(),
              qualityComments:
                ele.qualityComments === null ||
                  ele.qualityComments === undefined
                  ? ""
                  : ele.qualityComments.toString(),
            };
            delete data.sessionType;
            return data;
          })
          : filteredData.map((item) => {
            return {
              ...item,
              groupCode: item.groupCode === "" ? null : item.groupCode,
              myValuation:
                item.myValuation === NaN || item.myValuation === ""
                  ? null
                  : parseFloat(item.myValuation),
              myComments:
                item.myComments === undefined || item.myComments === ""
                  ? null
                  : item.myComments,
            };
          })
      )
      .then((res) => {
        if (res.data.statusCode === 202) {
          CustomToast.success(res.data.message);
          // CustomToast?.success(
          //   "Validation is successful; Please click on Submit button"
          // );
          setOpenDelete(true);
        } 
        else if (res.data.statusCode === 403) {
          CustomToast.warning(res.data.message);
        }
        else {
          CustomToast.error(res.data.message);
          setOpenDelete(false);
        }
        closeLoader();
      })
      .catch(() => closeLoader());

    // openLoader();
  };

  async function getSaleProgramId(season, saleNo) {
    if (parseInt(saleNo) > 0) {
      try {
        const response = await axiosMain.post(
          "/preauction/Common/GetSaleProgramDetailBySaleNo",
          {
            season: season?.toString(),
            saleNo: parseInt(saleNo),
            auctionCenterId: auctionCenterId,
          }
        );
        setSaleProgramid(response.data.responseData[0].SaleProgramId);
      } catch (error) {
        console.error("Error:", error);
        throw error; // Optionally, you can re-throw the error if you want to handle it elsewhere
      }
    } else {
      console.log("Logging...");
      return null; // Return null when saleNo is not greater than 0
    }
  }

  const handleData = async (uploadedData) => {
    //debugger;
    //debugger;

    try {
      const updatedFileData = [];
      // if (fileData.length > 0) {
      if (userRole === "auctioneer") {
        //debugger;

        uploadedData.map(({ fileName, data }, index) => {
          if (data && data?.length > 0) {
            const filteredData = data.filter((obj) => {
              // Check if any key in the object has a defined value
              return Object.values(obj).some((value) => value !== undefined);
            });

            const dataList = filteredData.map((ele) => {
              let data = {};
              if (baseUrlEng === "AuctionCatalog") {
                const {
                  ageOfProduct,
                  auctioneerValuation,
                  basePrice,
                  brewersComments,
                  colourOfBrew,
                  gardenCertification,
                  lotComments,
                  lotno,
                  markAndPackagingComments,
                  priceIncrement,
                  qualityCertification,
                  qualityComments,
                  reservePrice,
                  sampleqty,
                  sessionType,
                } = fixKeyNames(ele);


                data = {
                  KutchaCatalogId: 0,
                  invoiceId: 0,
                  ageOfProducts:
                    ageOfProduct === undefined ? null : ageOfProduct,
                  auctioneerValuation:
                    auctioneerValuation === undefined
                      ? null
                      : auctioneerValuation,
                  basePrice: basePrice === undefined ? null : basePrice,
                  brewersComments:
                    brewersComments === undefined ? null : brewersComments?.toString(),
                  brewColor: colourOfBrew === undefined ? null : colourOfBrew?.toString(),
                  gardenCertification:
                    gardenCertification === undefined
                      ? null
                      : gardenCertification?.toString(),
                  lotComments: lotComments === undefined ? null : lotComments?.toString(),
                  LotNo: lotno === undefined ? null : lotno?.replace(/\s/g, ""),
                  markPackageComments:
                    markAndPackagingComments === undefined
                      ? null
                      : markAndPackagingComments?.toString(),
                  priceIncrement:
                    priceIncrement === undefined ? null : priceIncrement,
                  qualityCertification:
                    qualityCertification === undefined
                      ? null
                      : qualityCertification?.toString(),
                  qualityComments:
                    qualityComments === undefined ? null : qualityComments?.toString(),
                  reservePrice: parseFloat(reservePrice),
                  SampleQty: sampleqty,
                  sessionType: sessionType?.toString(),
                  createdOn: null,
                  createdBy: userId, //auctioner
                  updatedBy: userId, //auctioner
                  updatedOn: null,
                  status: 1,
                  auctionCenterId: auctionCenterId,
                  saleprogramid: saleProgramid,
                };
              } else {
                const {
                  //ageOfProduct,
                  auctioneerValuation,
                  basePrice,
                  // brewersComments,
                  // colourOfBrew,
                  // gardenCertification,
                  lotComments,
                  lotno,
                  markAndPackagingComments,
                  // priceIncrement,
                  // qualityCertification,
                  qualityComments,
                  reservePrice,
                  sampleqty,
                  sessionType,
                } = fixKeyNames(ele);

                data = {
                  KutchaCatalogId: 0,
                  invoiceId: 0,
                  //ageOfProducts: ageOfProduct === undefined ? null : ageOfProduct,
                  auctioneerValuation:
                    auctioneerValuation === undefined
                      ? null
                      : auctioneerValuation,
                  basePrice: basePrice === undefined ? null : basePrice,
                  // brewersComments:
                  //   brewersComments === undefined ? null : brewersComments,
                  // brewColor: colourOfBrew === undefined ? null : colourOfBrew,
                  // gardenCertification:
                  //   gardenCertification === undefined
                  //     ? null
                  //     : gardenCertification,
                  lotComments: lotComments === undefined ? null : lotComments?.toString(),
                  LotNo: lotno === undefined ? null : lotno?.replace(/\s/g, ""),
                  markPackageComments:
                    markAndPackagingComments === undefined
                      ? null
                      : markAndPackagingComments?.toString(),

                  // qualityCertification:
                  //   qualityCertification === undefined
                  //     ? null
                  //     : qualityCertification,
                  qualityComments:
                    qualityComments === undefined ? null : qualityComments?.toString(),
                  reservePrice: parseFloat(reservePrice),
                  SampleQty: sampleqty === undefined ? 0 : sampleqty,
                  sessionType: sessionType?.toString(),
                  createdOn: null,
                  createdBy: userId, //auctioner
                  updatedBy: userId, //auctioner
                  updatedOn: null,
                  status: 1,
                  auctionCenterId: auctionCenterId,
                  saleprogramid: saleProgramid,
                  auctioneerId: userId,
                  auctionTypeMasterId: 2,
                  priceIncrement: 1,
                };
              }
              //debugger;
              return data;
            });

            // updatedFileData.push(filteredData);
            updatedFileData.push(dataList);

            // updatedFileData.push(filteredData);
          } else {
            // Handle the case where the data array is empty
            CustomToast.error(`No data found in file '${fileName}'`);
          }
        });
      } else {
        uploadedData.map(({ fileName, data }, index) => {
          if (data && data?.length > 0) {
            const filteredData = data.filter((obj) => {
              // Check if any key in the object has a defined value
              return Object.values(obj).some((value) => value !== undefined);
            });
            console.log(data, "datadata");

            const dataList = filteredData.map((ele) => {
              const { groupCode, myComments, myValuation, lotno } =
                fixKeyNames(ele);

              let data = {
                lotNo:
                  lotno === undefined || lotno === ""
                    ? ""
                    : lotno.replace(/\s/g, ""),
                myValuation:
                  myValuation === undefined || myValuation === ""
                    ? null
                    : myValuation,
                myComments: myComments?.toString(),
                groupCode: groupCode?.toString(),
                updatedBy: userId,
                createdBy: userId,
                auctionCenterId: auctionCenterId,
              };

              return data;
            });
            const blankLots = dataList
              .map((ele, index) => {
                if (
                  ele.lotNo === undefined ||
                  ele.lotNo === "" ||
                  ele.lotNo === null
                ) {
                  return index + 1;
                }
              })
              .filter(Boolean);

            // if (blankLots.length > 0) {
            //   CustomToast.error(
            //     "Please Enter Lot No in Row No " + blankLots.join(",")
            //   );
            //   return false;
            // }
            const numericIndices = dataList
              .map((ele, index) => {
                if (
                  typeof (ele.myValuation === null ? 0 : ele.myValuation) !==
                  "number"
                ) {
                  return index + 1;
                }
              })
              .filter(Boolean);
            // if (numericIndices.length > 0) {
            //   CustomToast.error(
            //     "Please Enter Numeric Value in My Valuation Row No " +
            //     numericIndices.join(",")
            //   );
            //   return false;
            // }
            // if (baseUrlEng === "EnglishAuctionBuyer") {
            const responseDataa = [
              { lotNo: "ABCDEF1234", gradeCode: "A1", markCode: "M1" },
              { lotNo: "002", gradeCode: "B1", markCode: "M2" },
            ];
            const count = 0;
            axiosMain
              .post(
                // `/preauction/${baseUrlEng}/GetMyCatalogValuation?role`,
                `/preauction/${baseUrlEng}/GetMyCatalogValuation?season=` +
                formik.values.season +
                "&saleNo=" +
                formik.values.saleNo,
                dataList.map((ele) => {
                  return {
                    ...ele,
                    myValuation: parseFloat(ele.myValuation),
                  };
                })
                // {
                //   lotNo: lotno.replace(/\s/g, ""),
                //   myValuation: parseFloat(myValuation),
                //   myComments: myComments,
                //   groupCode: groupCode,
                //   auctionCenterId: auctionCenterId,
                // }
              )
              .then((res) => {
                if (res.data.statusCode === 200) {
                  setvalCount(0);
                  setnewMessage("");
                  const newdatalist = dataList.map((itm) => {
                    const matchingItem = res.data.responseData.find(
                      (ele) => itm.lotNo === ele.lotNo
                    );
                    if (matchingItem) {
                      return {
                        ...itm,
                        gradeCode: matchingItem.gradeCode,
                        markCode: matchingItem.markCode,
                      };
                    }
                    return itm;
                  });

                  CustomToast.success(res.data.message);
                  setuploadRows(newdatalist);
                } else {
                  setvalCount(1);
                  // const newdatalist = dataList.map(itm => {
                  //   const matchingItem = res.data.responseData?.find(ele => itm.lotNo === ele.lotNo);
                  //   if (matchingItem) {
                  //     return { ...itm, gradeCode: matchingItem.gradeCode, markCode: matchingItem.markCode };
                  //   }
                  //   return itm;
                  // });
                  setuploadRows(dataList);
                  //CustomToast.error(res.data.message);
                  setnewMessage(res.data.message);
                }
              })
              .catch((err) => { });
            // }
            // updatedFileData.push(filteredData);
            updatedFileData.push(dataList);

            // updatedFileData.push(filteredData);
          } else {
            // Handle the case where the data array is empty
            CustomToast.error(`No data found in file '${fileName}'`);
          }
        });
      }

      // } else {
      //   CustomToast.error(`No file found in fields`);
      // }

      const mergedArray = updatedFileData.reduce((result, currentArray) => {
        return result.concat(currentArray);
      }, []);
      console.log(updatedFileData?.at(0), "updatedFileData");

      //allData(mergedArray);
      // if (invoiceData?.length > 0) {
      //   setInvoiceData([...invoiceData, ...dataList]);
      // } else {
      setValuationData([...valuationData, ...mergedArray]);
      if (baseUrlEng !== "EnglishAuctionBuyer") {
        setuploadRows([...valuationData, ...mergedArray]);
      }

      //}
      console.log(...mergedArray, "mergedArraymergedArray");
      console.log(valuationData, "invoiceDatainvoiceData");
    } catch (error) {
      CustomToast.error(error);
    }
    // validation(uploadedData);
  };
  const MAX_FILE_SIZE = 10 * 1024 * 1024;
  const ALLOWED_EXTENSIONS = [".xls", ".xlsx"];

  const handleFileUpload = async (e) => {
    //debugger;

    const files = e.target.files;
    const file = e.target.files[0];
    let boolcheckAllColumn;

    // if (file) {
    //   const reader = new FileReader();
    //   reader.onload = async (event) => {
    //     const binaryStr = event.target.result;
    //     const workbook = XLSX.read(binaryStr, { type: "binary" });
    //     const sheetName = workbook.SheetNames[0];
    //     const worksheet = workbook.Sheets[sheetName];
    //     const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    //     //debugger;
    //     if (jsonData.length > 0) {
    //       // Extract the headers (first row)
    //       console.log(jsonData[0]);
    //       const checkAllColumn = jsonData[0]?.map(ele => {
    //         return Object.keys(ele).some(key =>
    //           uploadtablecolumn.some(itm => itm.title === (ele === "LotNo" ? "Lot No" : ele))
    //         );

    //       });
    //       if (checkAllColumn.includes(false)) {
    //         boolcheckAllColumn = false;
    //       }
    //       else {
    //         boolcheckAllColumn = true;
    //       }
    //     }
    //   };
    //   reader.readAsBinaryString(file);
    // }

    let count = 0;
    for (const file of files) {
      try {
        boolcheckAllColumn = await checkAllcoulm(
          file,
          uploadtablecolumn.map((ele) =>
            ele.name === "auctioneerValuation"
              ? { ...ele, title: "Auctioneer Valuation" }
              : ele
          )
        );
        //debugger;
        const fileSize = file.size;
        const fileName = file.name;
        const fileExtension = fileName.slice(
          ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
        );
        if (!ALLOWED_EXTENSIONS.includes("." + fileExtension.toLowerCase())) {
          // CustomToast.error(
          //   `Only Excel files are allowed.`
          // );

          CustomToast.error(`Only Excel files are allowed.`);
        } else if (fileSize > MAX_FILE_SIZE) {
          CustomToast.error(`The file size should not exceed 10MB`);
        } else if (fileSize === 0) {
          CustomToast.error(`File with 0 KB size is not allowed`);
        } else {
          if (boolcheckAllColumn) {
            count = count + 1;
            const promises = Array.from(files).map((file) =>
              readFileAndCheckHeaders(file)
            );

            Promise.allSettled(promises)
              .then((results) => {
                const fulfilledResults = results.filter(
                  (result) => result.status === "fulfilled"
                );
                const dataFromFiles = fulfilledResults.map(
                  (result) => result.value
                );

                // const newcolumn = uploadtablecolumn.filter(ele => ele.name !== "gradeCode" && ele.name !== "groupCode")
                // const updatedTableColumns = uploadtablecolumn.map((el) => {
                //   if (el.name === "LotNo") {
                //     return { ...el, name: "lotno" };
                //   }
                //   else if (el.name === "markPackageComments") {
                //     return { ...el, name: "markAndPackagingComments" };
                //   }
                //   else if (el.name === "SampleQty") {
                //     return { ...el, name: "sampleqty" };
                //   }
                //   else {
                //     return el;
                //   }
                // });

                // const newdd = Object.keys(dataFromFiles[0].data?.at(0))?.map(ele => {
                //   return baseUrlEng === "EnglishAuctionBuyer" || baseUrlEng === "Buyer" ? newcolumn.some(itm => itm.name === ele) : updatedTableColumns.some(itm => itm.name === ele)
                // });
                // const newdd = dataFromFiles[0].data?.map(ele => {

                //   return Object.keys(ele).some(key =>
                //     baseUrlEng === "EnglishAuctionBuyer" || baseUrlEng === "Buyer" ? newcolumn.some(itm => itm.name === key) : uploadtablecolumn.some(itm => itm.name === key)
                //   );
                // });
                //debugger;
                if (dataFromFiles.length === count) {
                  handleData(dataFromFiles);
                }
              })
              .catch((errr) => console.log(errr));
          }
        }

        // Use vbool as needed
      } catch (error) {
        console.error("Error checking columns:", error);
      }
    }
  };
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div>
      {/* <Card className="mt-3 FileUploadBox">
        <Card.Body>
          <Card.Title>File Upload</Card.Title> */}

      <div className="row">
        <div className="col-12">
          <ul style={{ listStyle: "disc", paddingLeft: "1%" }}>
            <li>Any number of excel file can be uploaded </li>
            <li> Maximum file size should not exceed {"<10>"} MB</li>
            <li>Acceptable file types: (*.xls and.xlsx)</li>
          </ul>
        </div>

        <form onSubmit={formik.handleSubmit} className="col-md-12">
          <div className="row align-items-end">
            <div className="col-lg-2">
              <label>Season</label>
              <InputGroup>
                <FormControl
                  as="select"
                  name="season"
                  value={formik.values.season}
                  onChange={handleChange}
                >
                  <option value="">Please Select Season</option>
                  {generateYearOptions()}
                </FormControl>
              </InputGroup>
              {formik.errors.season && formik.touched.season && (
                <div className="error text-danger">{formik.errors.season}</div>
              )}
            </div>
            <div className="col-lg-2">
              <label>Sale No</label>
              <InputGroup>
                <FormControl
                  as="select"
                  name="saleNo"
                  value={formik.values.saleNo}
                  onChange={handleChange}
                >
                  <option value="0">Please Select Sale No</option>
                  {saleNumber?.map((e) => (
                    <option key={e.SaleNoId} value={e.saleNo}>
                      {e.saleNo}
                    </option>
                  ))}
                </FormControl>
              </InputGroup>
              {formik.errors.saleNo && formik.touched.saleNo && (
                <div className="error text-danger">{formik.errors.saleNo}</div>
              )}
            </div>
          </div>

          <div className="col-12 text-start">
            <button
              className="SubmitBtn mb-3"
              type="button"
              onClick={() => {
                fileInputRef.current.value = "";
                setuploadRows([]);
                setValuationData([]);
                setvalCount(0);
                setnewMessage("");
              }}
              style={{ borderRadius: "6px" }}
            >
              Clear
            </button>
          </div>
          <div className="row">
            <div className="col-12">
              {/* <br /> */}
              <div className="browse-file FileUpload px-0 mb-3">
                <button className="SubmitBtn" type="submit">
                  Browse
                </button>
                <input
                  type="file"
                  accept=".xls,.xlsx"
                  multiple
                  onChange={handleFileUpload}
                  ref={fileInputRef}
                />
                <button
                  className="SubmitBtn creat-btn"
                  type="button"
                  onClick={() => {
                    if (uploadrows.length > 0) {
                      handleSubmit();
                    } else {
                      if (fileInputRef.current.value === "") {
                        CustomToast.error("Please select excel file");
                      } else CustomToast.error("Validation is unsuccessful");
                    }
                  }}
                >
                  Validate
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div className="row">
        <div className="col-12">
          {/* <br /> */}

          {/* <button onClick={handleSubmit}>Upload</button> */}

          {/* <ToastContainer autoClose={1200}/> */}
          {
            uploadrows.length > 0 && (
              // (baseUrlEng === "EnglishAuctionCatalog" ||
              //   baseUrlEng === "EnglishAuctionKutchaCatalogue" ||
              //   baseUrlEng === "EnglishAuctionBuyer") ? (
              <div>
                <TableComponent
                  columns={uploadtablecolumn}
                  rows={uploadrows?.length > 0 ? uploadrows : []}
                  setRows={setuploadRows}
                  dragdrop={true}
                  module="pre-auction"
                  fixedColumnsOn={false}
                  resizeingCol={false}
                  selectionCol={true}
                  sorting={true}
                />
              </div>
            )

            // ) : (
            //   ""
            // )
          }
        </div>
      </div>
      {/* </Card.Body>
      </Card> */}
      <Modals
        show={openDelete}
        size="lg"
        // onHide={() => setShow(false)}
        handleClose={() => setOpenDelete(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        title="Are you sure you want to submit the valuation ?"
      >
        <div className="BtnGroup justify-end">
          <button
            className="SubmitBtn"
            onClick={() => {
              const filteredData = valuationData; //.filter((item) => item.LotNo !== null);

              openLoader();

              // if (invalidDataIndex === -1) {
              axiosMain
                .post(
                  userRole === "buyer"
                    ? `/preauction/${baseUrlEng}/AddValuation?validateAction=submit&dataFlag=Excel&season=` +
                    formik.values.season +
                    "&saleNo=" +
                    formik.values.saleNo
                    : kuchacatalogValuaction
                      ? `/preauction/EnglishAuctionKutchaCatalogue/UpdateKutchaCatalogueDetails?validateAction=submit&season=` +
                      formik.values.season +
                      "&saleNo=" +
                      formik.values.saleNo
                      : `/preauction/${baseUrlEng}/UploadValuation?role=` +
                      roleCode +
                      "&validateAction=submit&season=" +
                      formik.values.season +
                      "&saleNo=" +
                      formik.values.saleNo,
                  kuchacatalogValuaction
                    ? filteredData.map((ele) => {
                      delete ele.createdOn;
                      let data = {
                        ...ele,
                        saleNo: parseInt(auctionCatalogDetail.saleNo),
                        sessionTypeName: ele.sessionType,
                        lotComments: ele.lotComments === null || ele.lotComments === undefined ? "" : ele.lotComments?.toString(),
                        markPackageComments:
                          ele.markPackageComments === null || ele.markPackageComments === undefined ? "" : ele.markPackageComments.toString(),
                        qualityComments: ele.qualityComments === null || ele.qualityComments === undefined ? "" : ele.qualityComments.toString(),
                      };
                      delete data.sessionType;
                      return data;
                    })
                    : filteredData.map((item) => {
                      return {
                        ...item,
                        groupCode:
                          item.groupCode === "" ? null : item.groupCode,
                        myValuation:
                          item.myValuation === NaN || item.myValuation === ""
                            ? null
                            : parseFloat(item.myValuation),
                        myComments:
                          item.myComments === undefined ||
                            item.myComments === ""
                            ? null
                            : item.myComments,
                      };
                    })
                )
                .then((res) => {
                  if (res.data.statusCode === 200) {
                    CustomToast.success(res.data.message);
                    setValuationData([]);
                    setOpenUploadValuation(false);
                    if (kuchacatalogValuaction) {
                      getKuchaData();
                    } else {
                      if (userRole === "buyer") {
                        // axiosMain.post("/preauction/Buyer/AddToMyCatalog")
                        auctionCatalogDetail.tartTime = timeData
                          ?.split(" - ")
                          ?.at(0);
                        auctionCatalogDetail.sessionEndTime = timeData
                          ?.split(" - ")
                          ?.at(1);

                        axiosMain
                          .post(
                            `/preauction/${baseUrlEng}/GetMyCatalog?role=` +
                            roleCode,
                            {
                              season: auctionCatalogDetail.season,
                              saleNo: parseInt(auctionCatalogDetail.saleNo),
                              auctionDate: auctionCatalogDetail.auctionDate,
                              buyerId: userId,
                              sessionTime: auctionCatalogDetail.sessionTime,
                              teaTypeId: auctionCatalogDetail.teaType,
                              categoryId: auctionCatalogDetail.category,
                              sessionStartTime:
                                auctionCatalogDetail.sessionStartTime,
                              sessionEndTime:
                                auctionCatalogDetail.sessionEndTime,
                              auctionCenterId: auctionCenterId,
                            }
                          )
                          .then((res) => {
                            if (res.data.statusCode === 200) {
                              // CustomToast.success(res.data.message); //chenged  when update data then not show toster only update list of data
                              setMyCatalogRows(res.data.responseData);
                            } else {
                              //CustomToast.error(res.data.message);
                            }
                            closeLoader();
                          });

                        // console.log(KutchaCatalogId);
                      } else {
                        if (auctionCatalogDetail.saleNo !== "") {
                          auctionCatalogDetail.sessionStartTime =
                            auctionCatalogDetail.sessionTime
                              ?.at(0)
                              ?.SessionTime?.split(" - ")
                              ?.at(0);
                          auctionCatalogDetail.sessionEndTime =
                            auctionCatalogDetail.sessionTime
                              ?.at(0)
                              ?.SessionTime?.split(" - ")
                              ?.at(1);

                          let datatime;
                          let sttime;
                          let endtime;
                          if (
                            auctionCatalogDetail.sessionTime !== "" &&
                            auctionCatalogDetail.sessionTime !== undefined
                          ) {
                            datatime =
                              auctionCatalogDetail.sessionTime.split("-");
                            // sttime = datatime[0].slice(0, -5);
                            // endtime = datatime[1].slice(0, -4);
                            sttime = datatime[0].replace(" ", "");
                            endtime = datatime[1].replace(" ", "");
                          } else {
                            sttime = "";
                            endtime = "";
                          }
                          openLoader();

                          axiosMain
                            .post(
                              `/preauction/${baseUrlEng}/GetMyCatalog?role=` +
                              roleCode,
                              {
                                season: auctionCatalogDetail.season,
                                saleNo: parseInt(auctionCatalogDetail.saleNo),
                                auctionDate: auctionCatalogDetail.auctionDate,
                                // auctioneerId: auctionCatalogDetail.auctioneer,

                                auctioneerId: userId,
                                auctionCenterId: auctionCenterId,
                                userId: userId,
                                // userId: auctionCatalogDetail.auctioneer,
                                teaTypeId:
                                  teatypeList?.filter(
                                    (ele) =>
                                      ele.teatypeid ===
                                      parseInt(auctionCatalogDetail.teaType)
                                  )[0]?.teaTypeName === "BOTH"
                                    ? 0
                                    : parseInt(auctionCatalogDetail.teaType),
                                categoryId: auctionCatalogDetail.category,
                                sessionStartTime: sttime,
                                sessionEndTime: endtime,
                              }
                            )
                            .then((res) => {
                              if (res.data.statusCode === 200) {
                                CustomToast.success(res.data.message);
                                let data = res.data?.responseData?.map(
                                  (ele) => {
                                    return {
                                      ...ele,
                                      saleDate: formatDateToDdMmYy(
                                        ele.saleDate
                                      ),
                                      gpDate: formatDateToDdMmYy(ele.gpDate),
                                    };
                                  }
                                );
                                setMyCatalogRows(data);
                              } else {
                                CustomToast.error(res.data.message);
                              }
                              closeLoader();
                            });
                          console.log(auctionCatalogDetail);
                        }
                      }
                    }
                  } else if (res.data.statusCode === 204) {
                    CustomToast.warning(res.data.message);
                    setValuationData([]);
                    setOpenUploadValuation(false);
                  } else {
                    CustomToast.error(res.data.message);
                    setValuationData([]);
                    setOpenUploadValuation(false);
                  }
                  closeLoader();
                });
              //}
              // else {
              //   CustomToast.error("Please Enter Valid Auctioneer's Valuation,Sample Qty,Base Price,Reserve Price value");
              // }
              // console.log(rows, "rowrowrow");
              // let data = rows.map((ele) => {
              //   let results = {
              //     KutchaCatalogId: 0,
              //     invoiceId: 0,
              //     LotNo: "Sach123AHM2023301000-S",
              //     SampleQty: 10,
              //     basePrice: 100,
              //     reservePrice: 250,
              //     auctioneerValuation: 100,
              //     priceIncrement: 1,
              //     markPackageComments: "test",
              //     lotComments: "test",
              //     qualityComments: "test",
              //     qualityCertification: null,
              //     brewColor: "test",
              //     ageOfProducts: 2,
              //     brewersComments: "test",
              //     gardenCertification: "test",
              //     createdBy: userId,//auctioner
              //     createdOn: null,
              //     updatedBy: userId,//auctioner
              //     updatedOn: null,
              //     status: 1,
              //     saleprogramid: 10257,
              //   };

              //   return results;
              // });

              // axiosMain
              //   .post("/preauction/SampleShortage/UploadSampleShortage", data)
              //   .then((res) => {
              //     if (res.data.statusCode === 200) {
              //       CustomToast.success(res.data.message);
              //       setRows([]);
              //     } else {
              //       CustomToast.error(res.data.message);
              //     }
              //   });
            }}
          >
            Submit
          </button>

          <button
            className="SubmitBtn"
            onClick={() => {
              setOpenDelete(false);
              // setOpenModalConformationTitle("");
            }}
          >
            Cancel
          </button>
        </div>
      </Modals>
    </div>
  );
};

function UploadValuation({
  openUploadValuation,
  setOpenUploadValuation,
  auctionCatalogDetail,
  loggedUser,
  setMyCatalogRows,
  timeData,
  baseUrlEng,
  kuchacatalogValuaction,
  getKuchaData,
  userRole,
}) {
  return (
    <div className="invoice-modal">
      {openUploadValuation && (
        <Modal
          size="xl"
          title="Upload Valuation"
          show={openUploadValuation}
          handleClose={() => {
            setOpenUploadValuation(false);
          }}
        >
          <UploadValuationForm
            loggedUser={loggedUser}
            auctionCatalogDetail={auctionCatalogDetail}
            setOpenUploadValuation={setOpenUploadValuation}
            setMyCatalogRows={setMyCatalogRows}
            timeData={timeData}
            baseUrlEng={baseUrlEng}
            kuchacatalogValuaction={kuchacatalogValuaction}
            getKuchaData={getKuchaData}
            userRole={userRole}
          />
        </Modal>
      )}
    </div>
  );
}

export default UploadValuation;
